import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 flex flex-wrap items-center justify-between gap-3",
  "aria-label": "Pagination"
}
const _hoisted_2 = { class: "text-sm text-gray-500" }
const _hoisted_3 = { class: "font-medium text-gray-700" }
const _hoisted_4 = { class: "font-medium text-gray-700" }
const _hoisted_5 = { class: "font-medium text-gray-700" }
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "px-2 text-sm text-gray-400",
  "aria-hidden": "true"
}
const _hoisted_9 = ["aria-label", "aria-current", "disabled", "onClick"]
const _hoisted_10 = ["disabled"]

import { computed } from 'vue'

import { pageWindow } from './pageWindow'

const buttonClass =
  'min-w-[2rem] h-8 px-2 text-sm font-medium rounded-md border transition disabled:opacity-50 disabled:cursor-not-allowed'
const idleClass = 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50'
const currentClass = 'bg-brand-600 border-brand-600 text-white'


export default {
  __name: 'NeueNumberedPagination',
  props: {
  page: { type: Number, required: true },
  pageCount: { type: Number, required: true },
  totalCount: { type: Number, required: true },
  pageSize: { type: Number, required: true },
  loading: { type: Boolean, default: false }
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const pages = computed(() => pageWindow(props.page, props.pageCount))
const showingFrom = computed(() => (props.page - 1) * props.pageSize + 1)
const showingTo = computed(() => Math.min(props.page * props.pageSize, props.totalCount))

const goTo = n => {
  if (n === props.page || n < 1 || n > props.pageCount) return
  emit('change', n)
}

return (_ctx, _cache) => {
  return (__props.pageCount > 1)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _cache[2] || (_cache[2] = _createTextVNode(" Showing ", -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(showingFrom.value), 1),
          _cache[3] || (_cache[3] = _createTextVNode(" to ", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(showingTo.value), 1),
          _cache[4] || (_cache[4] = _createTextVNode(" of ", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.totalCount), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            "aria-label": "Previous page",
            class: _normalizeClass([buttonClass, idleClass]),
            disabled: __props.loading || __props.page <= 1,
            onClick: _cache[0] || (_cache[0] = $event => (goTo(__props.page - 1)))
          }, " ← ", 10, _hoisted_7),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (n, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: n === null ? `gap-${index}` : n
            }, [
              (n === null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "…"))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    "aria-label": `Page ${n}`,
                    "aria-current": n === __props.page ? 'page' : undefined,
                    class: _normalizeClass([buttonClass, n === __props.page ? currentClass : idleClass]),
                    disabled: __props.loading,
                    onClick: $event => (goTo(n))
                  }, _toDisplayString(n), 11, _hoisted_9))
            ], 64))
          }), 128)),
          _createElementVNode("button", {
            type: "button",
            "aria-label": "Next page",
            class: _normalizeClass([buttonClass, idleClass]),
            disabled: __props.loading || __props.page >= __props.pageCount,
            onClick: _cache[1] || (_cache[1] = $event => (goTo(__props.page + 1)))
          }, " → ", 10, _hoisted_10)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}